<template>
  <div>
    <div v-for="transaction in paginatedTransactions" :key="transaction.id" class="mb-3">
      <list-card
        :transaction="transaction"
        :search-query="searchQuery"
      />
    </div>
    <no-results v-show="!paginatedTransactions.length" />
  </div>
</template>

<script>
import ListCard from '@/components/common/List/ListCard'
import NoResults from '@/components/common/NoResults'
export default {
  props: {
    paginatedTransactions: {
      type: Array,
      default: () => []
    },
    searchQuery: {
      type: String,
      default: ''
    }
  },
  components: {
    ListCard,
    NoResults
  }
}
</script>
